module.exports = __webpack_public_path__ + "static/media/Coronary_Artery_Disease_226002HD.a9ed4572.mp4";